// extracted by mini-css-extract-plugin
export default {"deviceUsageType":"styles_deviceUsageType__qD+QV"};